<template>
  <transition name="slide-fade">
    <div class="warning-toast">
      <div class="margin-right-md">
        <i class="fas fa-exclamation-circle"></i>
      </div>

      <div>
        <p class="warning-toast__title margin-bottom-xs">
          {{ title }}
        </p>

        <p v-if="description">
          {{ description }}
        </p>

        <button
          class="tb-btn tb-btn-contained medium-em"
          data-entity="producer-warningReload"
          data-test="warning-toast"
          @click="onClickReload"
        >
          Reload
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },

    description: {
      type: String,
      default: '',
    },
  },

  methods: {
    onClickReload() {
      window.location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.warning-toast {
  z-index: 10000;
  position: fixed;
  bottom: calc(0.5rem + 40px);
  right: 1rem;
  border-left: 4px solid #e65447;
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.14), 0 3px 3px -2px rgba(0, 0, 0, 0.12), 0 1px 8px 0 rgba(0, 0, 0, 0.2);
  background: #121212;
  padding: 1rem 2rem;
  border-radius: 4px;
  display: flex;

  .fas {
    font-size: 24px;
    margin-top: 0.5rem;
  }
}

.warning-toast__title {
  font-weight: bold;
  font-size: 1.1em;
}
</style>
